import {
  create_col_style
} from '@/base/col_style_data';
export default {
  pc_infor:{
    col:12,
    padding_pattern:'default',//默认或自定义
    padding_left:"0%",
    padding_right:"0%",
    padding_top:"0%",
    padding_bottom:"0%",
    margin_pattern:'default',//默认或自定义
    margin_top: "0%",
    margin_bottom: "0%",
    margin_left: "0%",
    margin_right: "0%",
    is_shadow: 'false',
    border_set: {
      radio_val: 'default',
      default:{
        border_width: 0,
        border_left_width:0,
        border_right_width:0,
        border_top_width:0,
        border_bottom_width:0,
        border_color:'rgba(0,0,0,1)',
        border_style:'solid',
        border_check_list:[]
      },
      custom:{
        border_width: 0,
        border_left_width:0,
        border_right_width:0,
        border_top_width:0,
        border_bottom_width:0,
        border_color:'rgba(0,0,0,1)',
        border_style:'solid',
        border_check_list:['borderTopWidth','borderBottomWidth','borderLeftWidth','borderRightWidth']
      }
    },
    background_set:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 0)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
  },
  mb_infor:{
    col:1,
    order:0,//用于自定义排序用
    ...create_col_style()
  },
};



// WEBPACK FOOTER //
// ./src/widgets/layout_column_new/style.js